import './utils/vh.utils.js';
import './utils/animate-on-view.utils';
import './utils/parallax-on-view.utils.js';

import './components/header.component.js';
import './components/uploadFile.component.js';
import './components/authorization.component.js';
import './components/inputs.component.js';
import './components/animations.component.js';
import './components/jobs-search.component.js';
import './components/date.component.js';
import './components/accordion.component.js';
import './components/meta-select.component.js';
import './components/meta-range.component.js';

import './components/marquee.component.js';
import './components/together.component.js';
import './components/advice.component.js';
import './components/popular.component.js';

import './components/profile.component.js';

/*Sliders*/

import './components/swiper-employers.component.js';
import './components/swiper-sectors.component.js';
import './components/swiper-client.component.js';
import './components/swiper-popular.component.js';

import './components/swiper-purpose.component.js';
import './components/swiper-our-team.component.js';
import './components/swiper-testimonials.component.js';
import './components/swiper-similar.component.js';
import './components/swiper-with-us.component.js';
import './components/swiper-pricing.component.js';
import './components/swiper-similar-jobs.component.js';

/*import './components/swiper-employers.component.js';
import './components/swiper-jobs.component.js';
/*import './components/swiper-blogs.component.js';*/
import './components/swiper-trusted.component.js';
import './components/swiper-blogs.component.js';
import './components/swiper-we-offer.component.js';
import './components/swiper-clients-say-second.component.js';
/*Sliders End*/

import './components/overlayScroll.component.js';

import './libs/countUp.lib.js';

window.jsScrollToEl = function jsScrollToEl(targetID) {
  let config = targetID.split('|');
  let duration = +config[1] && +config[1] !== '' ? +config[1] : 800;
  let paddingTop = +config[2] && +config[2] !== '' ? +config[2] : 0;
  let target = config[0];
  let targetElement = document.querySelector(target);

  if (targetElement) {
    let targetOffsetTop = targetElement.offsetTop - paddingTop;
    window.scrollTo({
      top: targetOffsetTop,
      behavior: 'smooth',
    });
    return false;
  }
};

/* Filter Search Accordions */
const searchAccs = document.querySelectorAll('.filter-accordion');
const searchAccsTitles = document.querySelectorAll('.filter-accordion__title');

function setInitialState() {
  const windowWidth = window.innerWidth;

  searchAccs.forEach((acc, index) => {
    if (windowWidth <= 768) {
      acc.classList.toggle('active', index === 0);
    } else {
      acc.classList.add('active');
    }
  });
}

setInitialState();

window.addEventListener('resize', setInitialState);

searchAccsTitles.forEach((accTitle) => {
  accTitle.addEventListener('click', function (e) {
    e.preventDefault();
    this.closest('.filter-accordion').classList.toggle('active');
  });
});

/* HOVERS LINKS */

document.addEventListener('DOMContentLoaded', function () {
  const shareElements = document.querySelectorAll('.first-section__left-share');

  if (shareElements.length) {
    shareElements.forEach((item) => {
      item.addEventListener('click', function (event) {
        event.stopPropagation();
        item.classList.toggle('active');
      });

      // document.addEventListener('click', function(event) {
      //   if (!item.contains(event.target)) {
      //     item.classList.remove('active');
      //   }
      // });
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const shareElements = document.querySelectorAll('.similar-section__item-share');

  if (shareElements.length) {
    shareElements.forEach((item) => {
      item.addEventListener('click', function (event) {
        event.stopPropagation();
        item.classList.toggle('active');
      });
    });

    document.addEventListener('click', function (event) {
      shareElements.forEach((item) => {
        if (!item.contains(event.target)) {
          item.classList.remove('active');
        }
      });
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const shareWrappers = document.querySelectorAll('.share-wrapper');
  const shareButtons = document.querySelectorAll('.share');

  console.log(shareButtons);

  shareButtons.forEach((button, i) => {
    console.log(button);

    button.addEventListener('click', (event) => {
      event.stopPropagation();
      shareWrappers[i].classList.toggle('active');
    });

    document.addEventListener('click', (event) => {
      if (!shareWrappers[i].contains(event.target)) {
        shareWrappers[i].classList.remove('active');
      }
    });
  });
});

initChoices('[data-choices]');
document.querySelectorAll('[data-anchor]').forEach((anchor) => {
  console.log(anchor);
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  });
});

window.globalLoaderStart = function globalLoaderStart() {
  const loader = document.getElementById('global-loader');

  loader.style.opacity = '1';
  loader.style.pointerEvents = 'auto';
  scrollLock.disablePageScroll();
};

window.globalLoaderEnd = function globalLoaderEnd() {
  const loader = document.getElementById('global-loader');

  loader.style.opacity = '0';
  loader.style.pointerEvents = 'none';
  scrollLock.enablePageScroll();
};

window.workExperienceInit = function workExperienceInit() {
  const workExperienceElements = document.querySelectorAll(
    '[id^="section-work-experience-"]'
  );
  workExperienceElements.forEach((el) => {
    if (!el.classList.contains('is-init')) {
      el.classList.add('is-init');

      const checkbox = el.querySelector('[id^="is_present_"]');
      const endDate = el.querySelector('[name="end_date[]"]');

      if (checkbox && endDate) {
        const updateEndDateVisibility = () => {
          endDate.style.display = checkbox.checked ? 'none' : '';
        };

        updateEndDateVisibility();

        checkbox.addEventListener('change', updateEndDateVisibility);
      }
    }
  });
};

workExperienceInit();
